if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const sections = document.querySelectorAll(
    '#MainContent > div[id^="shopify-section-"]:not([id$="header-group"])'
  );

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      }
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );

  const viewportHeight = window.innerHeight;

  sections.forEach((section) => {
    const rect = section.getBoundingClientRect();
    const alreadyInView = rect.top < viewportHeight && rect.bottom > 0;

    // Anything already on screen (or above it) at load time must render
    // immediately - only content the user still has to scroll to reach
    // gets the fade-up treatment.
    if (alreadyInView) return;

    section.setAttribute('data-scroll-reveal', '');
    observer.observe(section);
  });
}
